import {
	EFontFamily,
	EFontWeight,
	ETextAlign,
	ETextTransform,
	EWhiteSpace
} from 'src/styles/theme/components/NGText/NGText.enum';
import { EMediaQuery, ETextColor } from 'src/styles/theme/utils/enums';
import {
	addFramesStyles,
	addHiddenRangesStyles,
	addMarginStyles,
	addPaddingStyles,
	addTransition,
	getTextColor,
	getThemeColor,
	mq,
	pixelToRem
} from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

const globalHeadingStyle = (p: any) => `
		display: inline-block;

		font-weight: 700;
		text-align: ${p.textAlign};

		${p.textAlign === ETextAlign.center ? 'width: 100%;' : ''}

		${addTransition()}

		${p.fontFamily ? `font-family: ${p.fontFamily};` : ''}

		${
			p.firstLetterFactor
				? css`
						&::first-letter {
							font-size: ${p.firstLetterFactor}em;
						}
				  `
				: ''
		}

		${addFramesStyles(p)}
		${addMarginStyles(p)}
		${addPaddingStyles(p)}
		${addHiddenRangesStyles(p)}

		${
			p.textColor === ETextColor.gradientGold
				? css`
						background-clip: text;
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
						background-image: linear-gradient(155.3deg, #9f8c6c 29.33%, #ffeecf 50.34%, #9f8c6c 70.95%);
				  `
				: `color: ${getTextColor(p)};`
		}

		${p.shadowColor ? `text-shadow: 0px 0px 12px ${getThemeColor(p.theme, p.shadowColor)};` : ''}

		${p.singleLine ? 'line-height: 1; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;' : ''}
		${p.whiteSpace ? `white-space: ${p.whiteSpace}` : ``};
		${p.fontWeight ? `font-weight: ${p.fontWeight === EFontWeight.bold ? '700' : p.fontWeight} !important;` : ''}
		${p.textTransform ? `text-transform: ${p.textTransform} !important;` : ''}
		${p.isHidden ? `opacity: 0;` : ''}
`;

export const StyledHeadingOne = styled.h1<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	textTransform?: ETextTransform;
	fontWeight?: EFontWeight;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(36)};
	line-height: ${pixelToRem(50)};

	${mq(
		EMediaQuery.md,
		`font-size: ${pixelToRem(26)};
			line-height: ${pixelToRem(39)};`
	)}

	${(p) => globalHeadingStyle(p)}
`;

export const StyledHeadingTwo = styled.h2<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	textTransform?: ETextTransform;
	fontWeight?: EFontWeight;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(26)};
	line-height: ${pixelToRem(39)};

	${mq(
		EMediaQuery.md,
		`
			font-size: ${pixelToRem(20)};
			line-height: ${pixelToRem(30)};
		`
	)}

	${(p) => globalHeadingStyle(p)}
`;

export const StyledHeadingThree = styled.h3<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	textTransform?: ETextTransform;
	fontWeight?: EFontWeight;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(20)};
	line-height: ${pixelToRem(30)};

	${mq(
		EMediaQuery.md,
		`font-size: ${pixelToRem(18)};
		line-height: ${pixelToRem(27)};`
	)}

	${(p) => globalHeadingStyle(p)}
`;

export const StyledHeadingFour = styled.h4<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	fontWeight?: EFontWeight;
	textTransform?: ETextTransform;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(14)};
	line-height: ${pixelToRem(21)};
	${mq(
		EMediaQuery.md,
		`font-size: ${pixelToRem(14)};
		line-height: ${pixelToRem(21)};`
	)}
	${(p) => globalHeadingStyle(p)};
`;

export const StyledHeadingFive = styled.h5<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	fontWeight?: EFontWeight;
	textTransform?: ETextTransform;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(14)};
	line-height: ${pixelToRem(21)};

	${(p) => globalHeadingStyle(p)};
`;

export const StyledHeadingSix = styled.h6<{
	textColor?: ETextColor;
	singleLine?: boolean;
	whiteSpace?: EWhiteSpace;
	textAlign?: ETextAlign;
	fontWeight?: EFontWeight;
	textTransform?: ETextTransform;
	style?: string;
	fontFamily?: EFontFamily;
}>`
	font-size: ${pixelToRem(12)};
	line-height: ${pixelToRem(16)};

	${(p) => globalHeadingStyle(p)};
`;
